import { render } from "./newLifeLao.vue?vue&type=template&id=214d75c6&scoped=true"
import script from "./newLifeLao.vue?vue&type=script&lang=js"
export * from "./newLifeLao.vue?vue&type=script&lang=js"

import "./newLifeLao.vue?vue&type=style&index=0&id=214d75c6&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214d75c6"]])

export default __exports__